import { useEffect, useState } from "react";
import TopNavbarMenus from "./Menus";
import { userCompanyId, userCounterId } from "../../../../utility/helpers";
import { get as getCounterData } from "../../../../services/counter.service";
import {
    getCompany,
    getCompanyConfigs,
} from "../../../../services/company.service";
import { useDispatch, useSelector } from "react-redux";
import TopNavbarTripSearch from "./TripSearch";
import {
    setCompanyConfig,
    setCounterInfo,
    setTravelMode,
} from "../../../../store/counterPanelTripSearch";
import "./tableStyle.css";

export default function TopNavbar() {
    const dispatch = useDispatch();
    const { counterInfo, companyConfig } = useSelector(
        (state) => state.counterPanelTripSearch
    );
    const userState = useSelector((state) => state.auth);
    const [currentUser, setCurrentUser] = useState(null);

    const getAndSetCompanyInfo = async () => {
        try {
            const companyId = userCompanyId();
            const companyConfigs = await getCompanyConfigs(companyId);
            const companyData = await getCompany(companyId, true);

            dispatch(setCompanyConfig(companyConfigs));
            dispatch(setTravelMode(companyData?.data?.data?.travel_mode));
        } catch (error) {
            console.log(error);
        }
    };

    const getAndSetCounterInfo = async () => {
        try {
            const counterId = userCounterId();
            if (counterId) {
                const response = await getCounterData(counterId, true);
                if (response?.data?.data?.id) {
                    dispatch(setCounterInfo(response.data.data));
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const loadDependency = async () => {
        await getAndSetCounterInfo();
        await getAndSetCompanyInfo();
    };

    useEffect(() => {
        loadDependency();
    }, []);

    useEffect(() => {
        if (userState.userData) setCurrentUser(userState.userData.user);
    }, [userState]);

    return (
        <>
            <TopNavbarMenus
                counterInfo={counterInfo}
                companyConfig={companyConfig}
                currentUser={currentUser}
            />
            <TopNavbarTripSearch
                currentUser={currentUser}
                companyConfig={companyConfig}
            />
        </>
    );
}
